<template>
  <Transition name="fade-up">
    <div
      v-show="isVisible"
      class="na-popup"
      :style="{
        top: posY + 'px',
        left: posX + 'px',
      }"
    >Not Available<br>in demo</div>
  </Transition>
</template>
<script>
  export default {
    data () {
      return {
        isVisible: false,
        posX: 0,
        posY: 0,
      }
    },
    
    watch: {
      isVisible () {
        if (!this.isVisible) return
        setTimeout(() => {
          this.isVisible = false
        }, 3000)
      }
    },

    mounted () {
      document.addEventListener('click', e => {
        if (e.target.classList.contains('na')) {
          this.posX = e.clientX
          this.posY = e.clientY
          this.isVisible = true
          console.log(e)
        }
      })
    }
  }
</script>
<style lang="scss">
.na-popup {
  font-family: var(--font-family);
  background-color: #fff;
  color: #000;
  padding: 1rem;
  text-align: center;
  position: fixed;
  transform: translate(-50%, -100%);
  z-index: 999;
  line-height: 1.1;
  border-radius: 0.5rem;
  width: 10rem;
  pointer-events: none;
  // overflow: hidden;
}

.fade-up {
  &-enter-active,
  &-leave-active {
    transition: all 0.5s ease-in-out;
  }

  &-enter-from,
  &-leave-to {
    transform: translate(-50%, -90%);
    opacity: 0;
  }
}
</style>